import _classCallCheck from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _defineProperty from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

var _Object$freeze;

// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

/*
 * This file contains information about particular algorithm suites used
 * within the encryption SDK.  In most cases, end-users don't need to
 * manipulate this structure, but it can occasionally be needed for more
 * advanced use cases, such as writing keyrings.
 *
 * Here we describe the overall shape of the Algorithm Suites used by the AWS Encryption
 * SDK for JavaScript.  Specific details for Node.js and WebCrypto can be found
 * in the respective files
 */
import { immutableClass, readOnlyProperty } from './immutable_class';
import { needs } from './needs';
/* References to https://docs.aws.amazon.com/encryption-sdk/latest/developer-guide/algorithms-reference.html
 * These define the possible parameters for algorithm specifications that correspond
 * to the Node.js or WebCrypto environment.
 * These parameters are composed into an algorithm suite specification for each
 * environment in the respective files.
 */

export var AlgorithmSuiteIdentifier;

(function (AlgorithmSuiteIdentifier) {
  AlgorithmSuiteIdentifier[AlgorithmSuiteIdentifier["ALG_AES128_GCM_IV12_TAG16"] = 20] = "ALG_AES128_GCM_IV12_TAG16";
  AlgorithmSuiteIdentifier[AlgorithmSuiteIdentifier["ALG_AES192_GCM_IV12_TAG16"] = 70] = "ALG_AES192_GCM_IV12_TAG16";
  AlgorithmSuiteIdentifier[AlgorithmSuiteIdentifier["ALG_AES256_GCM_IV12_TAG16"] = 120] = "ALG_AES256_GCM_IV12_TAG16";
  AlgorithmSuiteIdentifier[AlgorithmSuiteIdentifier["ALG_AES128_GCM_IV12_TAG16_HKDF_SHA256"] = 276] = "ALG_AES128_GCM_IV12_TAG16_HKDF_SHA256";
  AlgorithmSuiteIdentifier[AlgorithmSuiteIdentifier["ALG_AES192_GCM_IV12_TAG16_HKDF_SHA256"] = 326] = "ALG_AES192_GCM_IV12_TAG16_HKDF_SHA256";
  AlgorithmSuiteIdentifier[AlgorithmSuiteIdentifier["ALG_AES256_GCM_IV12_TAG16_HKDF_SHA256"] = 376] = "ALG_AES256_GCM_IV12_TAG16_HKDF_SHA256";
  AlgorithmSuiteIdentifier[AlgorithmSuiteIdentifier["ALG_AES128_GCM_IV12_TAG16_HKDF_SHA256_ECDSA_P256"] = 532] = "ALG_AES128_GCM_IV12_TAG16_HKDF_SHA256_ECDSA_P256";
  AlgorithmSuiteIdentifier[AlgorithmSuiteIdentifier["ALG_AES192_GCM_IV12_TAG16_HKDF_SHA384_ECDSA_P384"] = 838] = "ALG_AES192_GCM_IV12_TAG16_HKDF_SHA384_ECDSA_P384";
  AlgorithmSuiteIdentifier[AlgorithmSuiteIdentifier["ALG_AES256_GCM_IV12_TAG16_HKDF_SHA384_ECDSA_P384"] = 888] = "ALG_AES256_GCM_IV12_TAG16_HKDF_SHA384_ECDSA_P384";
  AlgorithmSuiteIdentifier[AlgorithmSuiteIdentifier["ALG_AES256_GCM_IV12_TAG16_HKDF_SHA512_COMMIT_KEY"] = 1144] = "ALG_AES256_GCM_IV12_TAG16_HKDF_SHA512_COMMIT_KEY";
  AlgorithmSuiteIdentifier[AlgorithmSuiteIdentifier["ALG_AES256_GCM_IV12_TAG16_HKDF_SHA512_COMMIT_KEY_ECDSA_P384"] = 1400] = "ALG_AES256_GCM_IV12_TAG16_HKDF_SHA512_COMMIT_KEY_ECDSA_P384";
})(AlgorithmSuiteIdentifier || (AlgorithmSuiteIdentifier = {}));

Object.freeze(AlgorithmSuiteIdentifier);
export var CommitmentPolicy;

(function (CommitmentPolicy) {
  CommitmentPolicy["FORBID_ENCRYPT_ALLOW_DECRYPT"] = "FORBID_ENCRYPT_ALLOW_DECRYPT";
  CommitmentPolicy["REQUIRE_ENCRYPT_ALLOW_DECRYPT"] = "REQUIRE_ENCRYPT_ALLOW_DECRYPT";
  CommitmentPolicy["REQUIRE_ENCRYPT_REQUIRE_DECRYPT"] = "REQUIRE_ENCRYPT_REQUIRE_DECRYPT";
})(CommitmentPolicy || (CommitmentPolicy = {}));

Object.freeze(CommitmentPolicy);
export var NonCommittingAlgorithmSuiteIdentifier = function () {
  var _AlgorithmSuiteIdenti = AlgorithmSuiteIdentifier,
      ALG_AES256_GCM_IV12_TAG16_HKDF_SHA512_COMMIT_KEY = _AlgorithmSuiteIdenti.ALG_AES256_GCM_IV12_TAG16_HKDF_SHA512_COMMIT_KEY,
      ALG_AES256_GCM_IV12_TAG16_HKDF_SHA512_COMMIT_KEY_ECDSA_P384 = _AlgorithmSuiteIdenti.ALG_AES256_GCM_IV12_TAG16_HKDF_SHA512_COMMIT_KEY_ECDSA_P384,
      NAME_ALG_AES256_GCM_IV12_TAG16_HKDF_SHA512_COMMIT_KEY = _AlgorithmSuiteIdenti[0x0478],
      NAME_ALG_AES256_GCM_IV12_TAG16_HKDF_SHA512_COMMIT_KEY_ECDSA_P384 = _AlgorithmSuiteIdenti[0x0578],
      NonCommittingAlgorithmSuiteIdentifier = _objectWithoutProperties(_AlgorithmSuiteIdenti, ["ALG_AES256_GCM_IV12_TAG16_HKDF_SHA512_COMMIT_KEY", "ALG_AES256_GCM_IV12_TAG16_HKDF_SHA512_COMMIT_KEY_ECDSA_P384", "1144", "1400"]);

  return NonCommittingAlgorithmSuiteIdentifier;
}();
export var CommittingAlgorithmSuiteIdentifier = function () {
  var _AlgorithmSuiteIdenti2 = AlgorithmSuiteIdentifier,
      ALG_AES128_GCM_IV12_TAG16 = _AlgorithmSuiteIdenti2.ALG_AES128_GCM_IV12_TAG16,
      ALG_AES192_GCM_IV12_TAG16 = _AlgorithmSuiteIdenti2.ALG_AES192_GCM_IV12_TAG16,
      ALG_AES256_GCM_IV12_TAG16 = _AlgorithmSuiteIdenti2.ALG_AES256_GCM_IV12_TAG16,
      ALG_AES128_GCM_IV12_TAG16_HKDF_SHA256 = _AlgorithmSuiteIdenti2.ALG_AES128_GCM_IV12_TAG16_HKDF_SHA256,
      ALG_AES192_GCM_IV12_TAG16_HKDF_SHA256 = _AlgorithmSuiteIdenti2.ALG_AES192_GCM_IV12_TAG16_HKDF_SHA256,
      ALG_AES256_GCM_IV12_TAG16_HKDF_SHA256 = _AlgorithmSuiteIdenti2.ALG_AES256_GCM_IV12_TAG16_HKDF_SHA256,
      ALG_AES128_GCM_IV12_TAG16_HKDF_SHA256_ECDSA_P256 = _AlgorithmSuiteIdenti2.ALG_AES128_GCM_IV12_TAG16_HKDF_SHA256_ECDSA_P256,
      ALG_AES192_GCM_IV12_TAG16_HKDF_SHA384_ECDSA_P384 = _AlgorithmSuiteIdenti2.ALG_AES192_GCM_IV12_TAG16_HKDF_SHA384_ECDSA_P384,
      ALG_AES256_GCM_IV12_TAG16_HKDF_SHA384_ECDSA_P384 = _AlgorithmSuiteIdenti2.ALG_AES256_GCM_IV12_TAG16_HKDF_SHA384_ECDSA_P384,
      NAME_ALG_AES128_GCM_IV12_TAG16 = _AlgorithmSuiteIdenti2[0x0014],
      NAME_ALG_AES192_GCM_IV12_TAG16 = _AlgorithmSuiteIdenti2[0x0046],
      NAME_ALG_AES256_GCM_IV12_TAG16 = _AlgorithmSuiteIdenti2[0x0078],
      NAME_ALG_AES128_GCM_IV12_TAG16_HKDF_SHA256 = _AlgorithmSuiteIdenti2[0x0114],
      NAME_ALG_AES192_GCM_IV12_TAG16_HKDF_SHA256 = _AlgorithmSuiteIdenti2[0x0146],
      NAME_ALG_AES256_GCM_IV12_TAG16_HKDF_SHA256 = _AlgorithmSuiteIdenti2[0x0178],
      NAME_ALG_AES128_GCM_IV12_TAG16_HKDF_SHA256_ECDSA_P256 = _AlgorithmSuiteIdenti2[0x0214],
      NAME_ALG_AES192_GCM_IV12_TAG16_HKDF_SHA384_ECDSA_P384 = _AlgorithmSuiteIdenti2[0x0346],
      NAME_ALG_AES256_GCM_IV12_TAG16_HKDF_SHA384_ECDSA_P384 = _AlgorithmSuiteIdenti2[0x0378],
      CommittingAlgorithmSuiteIdentifier = _objectWithoutProperties(_AlgorithmSuiteIdenti2, ["ALG_AES128_GCM_IV12_TAG16", "ALG_AES192_GCM_IV12_TAG16", "ALG_AES256_GCM_IV12_TAG16", "ALG_AES128_GCM_IV12_TAG16_HKDF_SHA256", "ALG_AES192_GCM_IV12_TAG16_HKDF_SHA256", "ALG_AES256_GCM_IV12_TAG16_HKDF_SHA256", "ALG_AES128_GCM_IV12_TAG16_HKDF_SHA256_ECDSA_P256", "ALG_AES192_GCM_IV12_TAG16_HKDF_SHA384_ECDSA_P384", "ALG_AES256_GCM_IV12_TAG16_HKDF_SHA384_ECDSA_P384", "20", "70", "120", "276", "326", "376", "532", "838", "888"]);

  return CommittingAlgorithmSuiteIdentifier;
}();
export var CommitmentPolicySuites = Object.freeze((_Object$freeze = {
  isEncryptEnabled: function isEncryptEnabled(commitmentPolicy, suite) {
    if (!suite) return;
    var id = suite.id || suite;
    var name = suite.name || AlgorithmSuiteIdentifier[id];
    /* Precondition: Only handle EncryptionMaterial for algorithm suites supported in commitmentPolicy. */

    needs(this[commitmentPolicy].encryptEnabledSuites[id], "Configuration conflict. " + "Cannot encrypt due to CommitmentPolicy ".concat(commitmentPolicy, " ") + "requiring only non-committed messages. " + "Algorithm ID was ".concat(name, ". ") + "See: https://docs.aws.amazon.com/encryption-sdk/latest/developer-guide/troubleshooting-migration.html");
  },
  isDecryptEnabled: function isDecryptEnabled(commitmentPolicy, suite, messageId) {
    var id = suite.id || suite;
    var name = suite.name || AlgorithmSuiteIdentifier[id];
    /* Precondition: Only handle DecryptionMaterial for algorithm suites supported in commitmentPolicy. */

    needs(this[commitmentPolicy].decryptEnabledSuites[id], "Configuration conflict. " + "Cannot process message with ID ".concat(messageId, " ") + "due to CommitmentPolicy ".concat(commitmentPolicy, " ") + "requiring only committed messages. " + "Algorithm ID was ".concat(name, ". ") + "See: https://docs.aws.amazon.com/encryption-sdk/latest/developer-guide/troubleshooting-migration.html");
  }
}, _defineProperty(_Object$freeze, CommitmentPolicy.FORBID_ENCRYPT_ALLOW_DECRYPT, Object.freeze({
  encryptEnabledSuites: NonCommittingAlgorithmSuiteIdentifier,
  decryptEnabledSuites: AlgorithmSuiteIdentifier,
  defaultAlgorithmSuite: NonCommittingAlgorithmSuiteIdentifier.ALG_AES256_GCM_IV12_TAG16_HKDF_SHA384_ECDSA_P384
})), _defineProperty(_Object$freeze, CommitmentPolicy.REQUIRE_ENCRYPT_ALLOW_DECRYPT, Object.freeze({
  encryptEnabledSuites: CommittingAlgorithmSuiteIdentifier,
  decryptEnabledSuites: AlgorithmSuiteIdentifier,
  defaultAlgorithmSuite: CommittingAlgorithmSuiteIdentifier.ALG_AES256_GCM_IV12_TAG16_HKDF_SHA512_COMMIT_KEY_ECDSA_P384
})), _defineProperty(_Object$freeze, CommitmentPolicy.REQUIRE_ENCRYPT_REQUIRE_DECRYPT, Object.freeze({
  encryptEnabledSuites: CommittingAlgorithmSuiteIdentifier,
  decryptEnabledSuites: CommittingAlgorithmSuiteIdentifier,
  defaultAlgorithmSuite: CommittingAlgorithmSuiteIdentifier.ALG_AES256_GCM_IV12_TAG16_HKDF_SHA512_COMMIT_KEY_ECDSA_P384
})), _Object$freeze));
export var MessageFormat;

(function (MessageFormat) {
  MessageFormat[MessageFormat["V1"] = 1] = "V1";
  MessageFormat[MessageFormat["V2"] = 2] = "V2";
})(MessageFormat || (MessageFormat = {}));

Object.freeze(MessageFormat);
export var AlgorithmSuite = function AlgorithmSuite(suiteValues) {
  _classCallCheck(this, AlgorithmSuite);

  needs(this.constructor !== AlgorithmSuite, 'new AlgorithmSuite is not allowed');
  /* Precondition: A algorithm suite specification must be passed. */

  needs(suiteValues, 'Algorithm specification not set.');
  /* Precondition: The Algorithm Suite Identifier must exist. */

  needs(AlgorithmSuiteIdentifier[suiteValues.id], 'No suite by that identifier exists.');
  Object.assign(this, suiteValues);
  readOnlyProperty(this, 'keyLengthBytes', this.keyLength / 8);
  readOnlyProperty(this, 'name', AlgorithmSuiteIdentifier[this.id]);
};
immutableClass(AlgorithmSuite);